<template>
    <div class="sp-dev-hyj-cmd-box">
        <div style="margin-bottom: 12px">
            <template  v-for="cmd in cmds" >
                <el-button  :key="cmd.cmd" size="mini" :type="currentCmd === cmd.cmd ? 'primary':''" @click="currentCmd=cmd.cmd">{{cmd.name}}</el-button>
            </template>
        </div>
        <shipment-cmd-box v-if="currentCmd === 'shipment'" :sn="sn"></shipment-cmd-box>
        <config-dev-num-cmd-box v-if="currentCmd === 'configDevNum'" :sn="sn" ></config-dev-num-cmd-box>
        <cancel-active-cmd-box  v-if="currentCmd === 'cancelActive'" :sn="sn"></cancel-active-cmd-box>
        <query-all-temp-cmd-box v-if="currentCmd === 'queryAllTemp'" :sn="sn"></query-all-temp-cmd-box>
        <config-temp-cmd-box v-if="currentCmd === 'configTemp'" :sn="sn"></config-temp-cmd-box>
        <config-cool-switch-box v-if="currentCmd === 'configCoolSwitch'" :sn="sn"></config-cool-switch-box>
    </div>
</template>

<script>
    import ShipmentCmdBox from "./ShipmentCmdBox";
    import ConfigDevNumCmdBox from "./ConfigDevNumCmdBox";
    import CancelActiveCmdBox from "./CancelActiveCmdBox";
    import QueryAllTempCmdBox from "./QueryAllTempCmdBox";
    import ConfigTempCmdBox from "./ConfigTempCmdBox";
    import ConfigCoolSwitchBox from "./ConfigCoolSwitchBox";
    export default {
        name: "SpDevHyjCmdBox",
        components: {
            ConfigCoolSwitchBox,
            ConfigTempCmdBox, QueryAllTempCmdBox, CancelActiveCmdBox, ConfigDevNumCmdBox, ShipmentCmdBox},
        props:{
            sn:{
                type:String,
                default:''
            }
        },
        data(){
            return {
                currentCmd:'shipment',
                cmds:[
                    {
                        name:'出货指令',
                        cmd:'shipment'
                    },
                    {
                        name:'设置编号',
                        cmd:'configDevNum'
                    },
                    {
                        name:'取消激活',
                        cmd:'cancelActive'
                    },
                    {
                        name:'查询温度',
                        cmd:'queryAllTemp'
                    },
                    {
                        name:'设置温度',
                        cmd:'configTemp'
                    },
                    {
                        name:'制冷开关设置',
                        cmd:'configCoolSwitch'
                    }
                ]
            }
        }
    }
</script>

<style scoped>

</style>